// extracted by mini-css-extract-plugin
module.exports = {"hidden":"gameWarning_hidden__QWg97","textEmphasis":"gameWarning_textEmphasis__7C10Q","warningWrap":"gameWarning_warningWrap__VPz_c"};